import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import FranquiaList from './FranquiaList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import FranquiaCadastrar from './FranquiaCadastrar';
import { Messages } from 'primereact/messages';
import postFranquia from "../../service/postFranquia";
import putFranquia from '../../service/putFranquia';

export default function FranquiaPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [franquia, setFranquia] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveFranquia = (franquia:any) => {
    if(franquia.id){
      putFranquia(franquia).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setFranquia(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    else{
      postFranquia(franquia).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setFranquia(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setFranquia({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-building" style={{ fontSize: '2.0rem' }}></i> {t('franquias')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!franquia && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <FranquiaList onEdit={(client:any) => { setFranquia(client);}}></FranquiaList>
          </>
        )}
        {franquia && (
          <>
           <FranquiaCadastrar msgs={msgs} franquia={franquia} onSave={saveFranquia} onClose={() => {setFranquia(null)}}></FranquiaCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
